import { Injectable } from '@angular/core'
import { AppBasicService } from '@data/service/app-basic.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class InnplaceService extends AppBasicService {
   getAllLists(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/combo`)
   }

   getPrefilterList_sectors(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/groupby/SECTORS`, this.httpOptions).pipe(
         map((res: any) => {
            return res.map((row) => this.dataSrv.mapPrefilter(row, 'pno_sectors'))
         })
      )
   }

   getPrefilterList_services(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/groupby/SERVICES`, this.httpOptions).pipe(
         map((res: any) => {
            return res.map((row) => this.dataSrv.mapPrefilter(row, 'services'))
         })
      )
   }

   getPrefilterList_grants(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/groupby/GRANT_PROGRAMME`, this.httpOptions).pipe(
         map((res: any) => {
            return res.map((row) => this.dataSrv.mapPrefilter(row, 'grants'))
         })
      )
   }
}

